<template>
  <el-row class="container" :class="{ embed: embed }" v-loading="status < 2" @mousedown.native="userActivate">
    <!--头部-->
    <el-col :span="24" class="topbar-wrap">
      <div class="topbar-logo topbar-btn" v-show="status >= 3">
        <a href="#/">
          <img v-if="currentMerchantInfo.logo" height="40" :src="currentMerchantInfo.logo" style="padding:0 8px;">
          <img v-else src="../assets/logo.png" width="48" height="40" style="padding-left:8px;">
        </a>
      </div>
      <div class="topbar-logos" v-show="(!collapsed) && status >= 3">
        <a href="#/">
          <span v-if="currentMerchantInfo.shortName" style="font-size: 24px; line-height: 50px; color: #fff;">{{currentMerchantInfo.shortName}}</span>
          <img v-else src="../assets/logo_txt.png" width="140" height="40" >
        </a>
      </div>
      <div class="topbar-title">
        <!-- <span>智慧城市用电安全云平台</span> -->
      </div>
      <div class="topbar-account topbar-btn">
        <!-- <el-row>
          <el-col :span="20"> -->
        组织：
        <el-select v-model="merchantOpenId" @change="merchantChange" placeholder="组织" filterable class="merchantSelect">
          <el-option v-for="item in merchantList" :key="item.merchantOpenId" :label="item.merchantName" :value="item.merchantOpenId"></el-option>
        </el-select>
        <!-- </el-col>
          <el-col :span="4"> -->
        <el-dropdown trigger="click" class="userDropdownMenu">
          <span class="el-dropdown-link userinfo-inner">
            <img v-if="sysUserAvatar" :src="sysUserAvatar" style="width: 32px; height: 32px; vertical-align: middle;" />
            <i v-else class="fa fa-user-o fa-fw"></i>
             {{sysUserName}}
            <i class="fa fa-caret-down fa-fw"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <el-button size="mini" @click="fontSize(12)"><i class="fa fa-font" style="font-size: 12px;"></i></el-button>
              <el-button size="mini" @click="fontSize(14)"><i class="fa fa-font" style="font-size: 14px;"></i></el-button>
              <el-button size="mini" @click="fontSize(16)"><i class="fa fa-font" style="font-size: 16px;"></i></el-button>
            </el-dropdown-item>
            <!-- <el-dropdown-item>
                  <router-link to="/merchant/accountInfo"><span style="color: #555;font-size: 14px;">账户信息</span></router-link>
                </el-dropdown-item> -->
            <!-- <el-dropdown-item>
                  <router-link :to="'/user/changepwd'"><span style="color: #555;font-size: 14px;">修改密码</span></router-link>
                </el-dropdown-item> -->
            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- </el-col>
        </el-row> -->
      </div>
    </el-col>

    <!--中间-->
    <el-col :span="24" class="main" v-if="status >= 2">
      <!--左侧导航-->
      <aside :class="{showSidebar:!collapsed}">
        <!--展开折叠开关-->
        <div class="menu-toggle" @click.prevent="collapse">
          <i class="fa fa-outdent fa-fw" v-show="!collapsed"></i>
          <i class="fa fa-indent fa-fw" v-show="collapsed"></i>
        </div>
        <!--导航菜单-->
        <el-menu default-active="menuActive" ref="leftMenu" :router="true" :collapse="collapsed">
          <template v-for="(item,index) in $router.options.routes" v-if="item.menuShow">
            <el-submenu v-if="(!item.leaf) &&hasMod(item.mod)" :index="item.path" popper-class="pop-menu">
              <template slot="title">
                <i :class="item.iconCls"></i>
                <span slot="title">{{item.name}}</span>
              </template>
              <el-menu-item v-for="term in item.children" :key="term.path" :index="term.path" v-if="term.menuShow &&hasMod(item.mod) && (!term.role || hasRole(term.role))" :class="$route.path==term.path?'active':''">
                <i :class="term.iconCls"></i>
                <span slot="title">{{term.name}}</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item v-else-if="item.leaf&&item.children&&item.children.length&&hasMod(item.mod)&&(!item.children[0].role || hasRole(item.children[0].role))" :index="item.children[0].path" :class="$route.path==item.children[0].path?'active':''">
              <i :class="item.iconCls"></i>
              <span slot="title">{{item.children[0].name}}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </aside>

      <!--右侧内容区-->
      <section class="content-container">
        <router-view></router-view>
      </section>
    </el-col>

  </el-row>
</template>

<script>
import bus from '../util/bus'
import store from '../util/store'
import { userInfo, myMerchant, logout, logoutSync, merchantInfoDetail } from '../api/api'
export default {
  data () {
    return {
      status: 0,
      sysUserName: '',
      sysUserAvatar: '',
      collapsed: false,
      menuActive: '1',
      merchantOpenId: '',
      currentMerchantInfo: {},
      merchantList: [],
      lastActivateTime: new Date(),
      userActivateInterval: 0,
      embed: false
    }
  },
  methods: {
    // 折叠导航栏
    collapse: function () {
      this.collapsed = !this.collapsed
    },
    hasRole (role) {
      return store.hasRole(role)
    },
    hasMod (mod) {
      return store.hasMod(mod)
    },
    logout () {
      var _this = this
      this.$confirm('确认退出吗?', '提示', {
        // type: 'warning'
      }).then(() => {
        logout().then(() => {
          console.log('logout')
        }).finally(() => {
          store.setToken('')
          _this.$router.push('/login')
        })
      })
    },
    merchantChange () {
      for (var item of this.merchantList) {
        if (this.merchantOpenId === item.merchantOpenId) {
          store.setMerchantInfo(item)
        }
      }
      setTimeout(() => {
        this.$router.push('/login')
      }, 500)
    },
    fontSize (value) {
      let body = document.getElementsByTagName('body')[0]
      if (body) {
        if (value >= 12 && value <= 18) {
          localStorage.setItem('fontSize', value)
          body.style.fontSize = `${value}px`
        }
      }
    },
    beforeunloadHandler () {
      this._beforeUnload_time = new Date().getTime()
    },
    unloadHandler: function (e) {
      let gapTime = new Date().getTime() - this._beforeUnload_time
      // 判断是窗口关闭还是刷新
      if (gapTime <= 5) {
        localStorage.setItem('logout', 'yes')
        logoutSync()
        localStorage.setItem('logout2', 'yes')
      }
    },
    userActivate () {
      this.lastActivateTime = new Date()
      // console.log(this.lastActivateTime)
    }
  },
  created () {
    // 监听用户信息修改事件
    bus.$on('setUserInfo', (userInfo) => {
      this.sysUserName = userInfo.name
      this.sysUserAvatar = userInfo.avatar
    })

    // 监听Api接口错误
    bus.$on('apiError', (data) => {
      if (!data || !data.resCode) return
      // 提示错误
      this.$message({
        message: data.resDesc,
        type: 'error'
      })
      // 401：需要登录
      if (data.resCode === '401') {
        this.$router.push({ path: '/login' })
      }
    })

    // 监听网络错误
    bus.$on('networkError', (data) => {
      if (!data) return
      // 提示错误
      this.$message({
        message: data,
        type: 'error'
      })
    })

    // 处理传递参数
    if (this.$route.query.embed) {
      sessionStorage.setItem('embed', true)
    }
    this.embed = sessionStorage.getItem('embed')
    if (this.$route.query.orgId) {
      localStorage.setItem('hudson.power.selectMerchantOpenId', this.$route.query.orgId)
    }

    // 初始化系统
    if (!store.token) {
      this.$router.push({ path: '/login' })
      return
    }

    // 设置字体大小
    let fontSize = parseInt(localStorage.getItem('fontSize'))
    this.fontSize(fontSize)

    userInfo({}).then((data) => {
      store.setUserInfo(data.result)
      this.status++
    })
    myMerchant({}).then((data) => {
      this.merchantList = data.result
      if (this.merchantList && this.merchantList.length > 0) {
        let storedMerchantOpenId = localStorage.getItem('hudson.power.selectMerchantOpenId')
        if (storedMerchantOpenId) {
          for (var item of this.merchantList) {
            if (storedMerchantOpenId === item.merchantOpenId) {
              this.merchantOpenId = storedMerchantOpenId
              store.setMerchantInfo(item)
              merchantInfoDetail({merchantOpenId: this.merchantOpenId}).then((data) => {
                this.currentMerchantInfo = data.result
                this.status++
              })
              this.status++
              return
            }
          }
        }
        this.merchantOpenId = this.merchantList[0].merchantOpenId
        store.setMerchantInfo(this.merchantList[0])
        merchantInfoDetail({merchantOpenId: this.merchantOpenId}).then((data) => {
          this.currentMerchantInfo = data.result
          this.status++
        })
        this.status++
      } else {
        this.$message({ message: '未开通任何权限，请联系管理员处理！', type: 'error' })
      }
    })
  },
  mounted () {
    this.$router.afterEach((to, from) => {
      this.menuActive = to.path
      if (this.$refs && this.$refs.leftMenu) {
        for (let item of to.matched) {
          if (this.$refs.leftMenu.submenus[item.path]) this.$refs.leftMenu.open(item.path)
        }
      }
    })

    // 检测用户是否使用，超时就退出登录
    this.userActivateInterval = window.setInterval(() => {
      if (new Date().getTime() - this.lastActivateTime.getTime() > 3600 * 1000) {
        this.$notify({
          title: '警告',
          message: '由于长时间未操作，系统即将退出登录...',
          duration: 10000,
          type: 'warning',
          onClick: (e) => {
            this.lastActivateTime = new Date()
          }
        })
        setTimeout(() => {
          if (new Date().getTime() - this.lastActivateTime.getTime() > 3600 * 1000) {
            logout().then(() => {
            }).finally(() => {
              store.setToken('')
              this.$router.push('/login')
              this.$notify({
                title: '警告',
                message: '由于长时间未操作，系统已自动退出登录.',
                duration: 0,
                type: 'warning'
              })
            })
          }
        }, 10000)
      }
    }, 12000)

    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
    window.addEventListener('unload', e => this.unloadHandler(e))
  },
  destroyed () {
    window.clearInterval(this.userActivateInterval)
    window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
    window.removeEventListener('unload', e => this.unloadHandler(e))
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "src/style/variables";

.container {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;

  .topbar-wrap {
    height: 50px;
    line-height: 50px;
    background: #0c3d73;
    padding: 0px;

    .topbar-btn {
      color: #fff;
    }
    /*.topbar-btn:hover {*/
    /*background-color: #4A5064;*/
    /*}*/
    .topbar-logo {
      float: left;
      // width: 59px;
      line-height: 26px;
    }
    .topbar-logos {
      float: left;
      // width: 120px;
      line-height: 26px;
    }
    .topbar-logo img,
    .topbar-logos img {
      height: 40px;
      margin-top: 5px;
      margin-left: 2px;
    }
    .topbar-title {
      float: left;
      text-align: left;
      font-size: 32px;
      font-weight: 600;
      color: #fff;
      // width: 500px;
      padding-left: 300px;
      // border-left: 1px solid #222;
    }
    .topbar-account {
      float: right;
      padding-right: 12px;
    }
    .userinfo-inner {
      cursor: pointer;
      color: #fff;
      padding-left: 10px;
      font-size: 16px;
    }
  }
  .main {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    position: absolute;
    top: 50px;
    bottom: 0px;
    overflow: hidden;
  }

  aside {
    min-width: 50px;
    background: #0c3d73;
    // background: #333744;
    &::-webkit-scrollbar {
      display: none;
    }

    &.showSidebar {
      overflow-x: hidden;
      overflow-y: auto;
    }

    /deep/ .el-menu {
      height: 100%; /*写给不支持calc()的浏览器*/
      height: -moz-calc(100% - 40px);
      height: -webkit-calc(100% - 40px);
      height: calc(100% - 40px);
      border-radius: 0px;
      // background-color: #333744;
      width: 200px;
      border: 0;
      background-color:transparent;

      i {
        color: #fff;
        padding-right: 8px;
      }
      .el-menu-item,
      .el-submenu__title {
        color: #fff;
      }
      .el-menu-item:hover,
      .el-submenu__title:hover,
      .el-menu-item:focus,
      .el-submenu__title:focus {
        background-color: rgba(255, 255, 255, .1);
        color: #fff;
      }
    }

    /deep/ .el-submenu .el-menu-item.active,
    /deep/ .el-menu-item.active,
    /deep/.el-submenu .el-menu-item.active:hover,
    /deep/ .el-menu-item.active:hover {
      background-color: rgba(255, 255, 255, .2) !important;
      color: #fff;
    }

    /deep/ .el-submenu .el-menu-item {
      min-width: 60px;
      color: #fff;
    }

    /deep/ .el-menu--collapse {
      width: 60px;
    }

    // .el-menu .el-menu-item, .el-submenu .el-submenu__title {
    //   height: 46px;
    //   line-height: 46px;
    // }

    // .el-menu-item:hover, .el-submenu .el-menu-item:hover, .el-submenu__title:hover {
    //   background-color: #7ed2df;
    // }
  }

  .menu-toggle {
    background: rgba(0, 0, 0, .2);
    text-align: center;
    color: #fff;
    height: 32px;
    line-height: 32px;
    &:hover {
      background: rgba(0, 0, 0, .1);
    }
  }

  .content-container {
    background: lighten(#0c3d73, 70%);
    flex: 1;
    overflow-y: auto;
    // padding: 10px;
    // padding-bottom: 1px;
    position: relative;
  }
}

.embed {
  .topbar-wrap {
    display: none;
  }
  .main {
    top: 0;
  }
}

</style>
